import { useEffect, useRef, useState } from 'react';

const services = [
  {
    icon: 'ri-cloud-line',
    title: '経理代行業務の一括管理',
    description:
      'クラウド型システムにより、経理代行業務を一括管理。複数拠点・複数企業の経理データを一元的に処理し、業務の標準化と効率化を実現します。',
    tags: ['クラウド管理', '一括処理', '標準化'],
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'データ管理・可視化',
    description:
      '売上・入出金・請求・支払情報をリアルタイムで集計・可視化。経営判断に必要なデータをダッシュボードで直感的に把握できます。',
    tags: ['リアルタイム', 'ダッシュボード', '可視化'],
  },
  {
    icon: 'ri-database-2-line',
    title: '業務支援システムの構築',
    description:
      '顧客ごとの経理データを集約・処理する業務支援システムを構築。データの正確性と処理速度を高め、経理担当者の負担を大幅に軽減します。',
    tags: ['データ集約', '自動処理', '精度向上'],
  },
  {
    icon: 'ri-settings-3-line',
    title: 'カスタマイズ開発・保守運用',
    description:
      '業務効率化を目的としたカスタマイズ開発および保守運用を提供。お客様の業務フローに合わせた柔軟なシステム構築が可能です。',
    tags: ['カスタマイズ', '保守運用', '柔軟対応'],
  },
];

export default function ServicesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="bg-[#0f1115] py-24 md:py-32" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div
          className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="text-xs font-semibold tracking-widest text-[#38bdf8] uppercase mb-3 block">Services</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>
            業務内容
          </h2>
          <p className="text-gray-300 text-[15px] mt-4 max-w-xl mx-auto leading-relaxed">
            経理業務のデジタル化・自動化を通じて、企業の成長を支援します。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div
              key={s.title}
              className={`group bg-[#1a1d23] border border-white/5 rounded-xl p-6 hover:border-[#38bdf8]/40 transition-all duration-500 cursor-default ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 100 + 200}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#38bdf8]/10 mb-5 group-hover:bg-[#38bdf8]/20 transition-colors">
                <i className={`${s.icon} text-[#38bdf8] text-xl`} />
              </div>
              <h3 className="text-white font-semibold text-[15px] mb-3 leading-snug">{s.title}</h3>
              <p className="text-gray-300 text-sm leading-relaxed mb-4">{s.description}</p>
              <div className="flex flex-wrap gap-1.5">
                {s.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 rounded-full bg-[#38bdf8]/10 text-[#38bdf8] text-xs"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
